import profissionalImagePNG from '../assets/images/checkout-products-images/profissional-image.png';
import biotypeDiagnosisPNG from '../assets/images/checkout-products-images/biotype-diagnosis.png';
import virtualTryOn10PNG from '../assets/images/checkout-products-images/virtual-try-on-10.png';
import virtualTryOn25PNG from '../assets/images/checkout-products-images/virtual-try-on-25.png';
import virtualTryOn50PNG from '../assets/images/checkout-products-images/virtual-try-on-50.png';
import styleDiagnosisPNG from '../assets/images/checkout-products-images/style-diagnosis.png';
import removalBg100PNG from '../assets/images/checkout-products-images/100-removal-bg.png';
import removalBg50PNG from '../assets/images/checkout-products-images/50-removal-bg.png';
import removalBgPNG from '../assets/images/checkout-products-images/removal-bg.png';
import card15Looks from '../assets/images/outfits-montage-icons/card-15-looks.png';
import card10Looks from '../assets/images/outfits-montage-icons/card-10-looks.png';
import card5Looks from '../assets/images/outfits-montage-icons/card-5-looks.png';

export const productsData = [
  {
    id: 1,
    productImage: removalBgPNG,
    type: 'Remoção de fundo',
    productName: 'Remoção de fundo',
    routeParam: 'Remocao de fundo',
    originalPrice: 1990,
    removalLevels: 30,
    price: 1990,
  },
  {
    id: 2,
    productImage: removalBg50PNG,
    type: 'Remoção de fundo',
    productName: '50 Removedores de fundo',
    routeParam: '50 Removedores de fundo',
    originalPrice: 390,
    removalLevels: 5,
    price: 390,
  },
  {
    id: 3,
    productImage: removalBg100PNG,
    type: 'Remoção de fundo',
    productName: '100 Removedores de fundo',
    routeParam: '100 Removedores de fundo',
    originalPrice: 690,
    removalLevels: 10,
    price: 690,
  },
  {
    id: 4,
    productImage: biotypeDiagnosisPNG,
    type: 'Diagnóstico',
    productName: 'Diagnóstico de biotipo',
    routeParam: 'Diagnostico de biotipo',
    originalPrice: 1990,
    removalLevels: null,
    price: 1990,
  },
  {
    id: 5,
    productImage: styleDiagnosisPNG,
    type: 'Diagnóstico',
    productName: 'Diagnóstico de estilo',
    routeParam: 'Diagnostico de estilo',
    originalPrice: 3990,
    removalLevels: null,
    price: 3990,
  },
  {
    id: 6,
    productImage: profissionalImagePNG,
    type: 'Curso',
    productName: 'Imagem profissional',
    routeParam: 'Imagem profissional',
    originalPrice: 39900,
    removalLevels: null,
    price: 19900,
  },
  {
    id: 7,
    productImage: card5Looks,
    type: 'Montagem de looks Sophia',
    productName: 'Montagem de 5 looks',
    routeParam: 'Montagem de 5 looks',
    originalPrice: 299,
    removalLevels: null,
    price: 299,
  },
  {
    id: 8,
    productImage: card10Looks,
    type: 'Montagem de looks Sophia',
    productName: 'Montagem de 10 looks',
    routeParam: 'Montagem de 10 looks',
    originalPrice: 399,
    removalLevels: null,
    price: 399,
  },
  {
    id: 9,
    productImage: card15Looks,
    type: 'Montagem de looks Sophia',
    productName: 'Montagem de 15 looks',
    routeParam: 'Montagem de 15 looks',
    originalPrice: 499,
    removalLevels: null,
    price: 499,
  },
  {
    id: 10,
    productImage: virtualTryOn10PNG,
    type: 'Provador virtual',
    productName: '10 Provadores virtuais',
    routeParam: '10 Provadores virtuais',
    originalPrice: 1290,
    virtualTryOnsQty: 10,
    price: 1290,
  },
  {
    id: 11,
    productImage: virtualTryOn25PNG,
    type: 'Provador virtual',
    productName: '25 Provadores virtuais',
    routeParam: '25 Provadores virtuais',
    originalPrice: 2690,
    virtualTryOnsQty: 25,
    price: 2690,
  },
  {
    id: 12,
    productImage: virtualTryOn50PNG,
    type: 'Provador virtual',
    productName: '50 Provadores virtuais',
    routeParam: '50 Provadores virtuais',
    originalPrice: 5490,
    virtualTryOnsQty: 50,
    price: 5490,
  },
];
